<template>
  <a-select
      v-model:value="model.roleIds"
      mode="multiple"
      style="width: 100%"
      placeholder="请选择角色"
      option-label-prop="label"
  >
    <a-select-option  v-for="d in data"  :value="d.roleId" :label="d.roleName">
      {{d.roleName}}
    </a-select-option>
  </a-select>
</template>
<script>
import roleApi from '@axios/sys/role'
import {ref} from "vue";
export default {
  componentname: "selectRoleList",
  props:{
    title:{
      type:String,
      default:'请选择角色'
    },
    disabled : {
      type:Boolean,
      default:false
    },
    model : {
      type : Object,
      default : function(){
        return {
          roleIds : undefined
        }
      }
    }
  },
  setup(props,context){
    let fetching = ref(false);
    let roleIds = ref([]);

    let data = ref([])
    const roleList = ( value ) => {
      let params = {}
      fetching.value = true;
      roleApi.roleList(params).then((res)=>{
        console.log(res)
        data.value = res
        fetching.value = false;
      }).catch(()=>{
        fetching.value = false;
      })
    }

    const change = (value) => {
      if(value){
        data.value.forEach((ele)=>{
          if(ele.id == value){

            context.emit('setValue',{
              val : value
            });
          }
        })
      }else{
        context.emit('setValue',{
          val : null
        });
      }

    }

    roleList();

    return {
      change,
      roleList,
      fetching,
      roleIds,
      data,
      model : props.model
    }
  }
};
</script>
